/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneOptionSingle/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaSelectOneOptionSingle({
  children,
  viewPath = "/DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/TysiaSelectOneOption/TysiaSelectOneOptionSingle",
  alignItems = "center",
  disabled,
  width = "auto",
  onClick,
  onMouseDown,
  selected,
  size,
  text,
  subtext
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<button
  data-testid="TysiaSelectOneOptionSingle.Horizontal"
  data-view-path={viewPath}
 role="option"
 tabIndex={-1}
 disabled={disabled}
 {...isHoveredBind}
 onClick={onClick}
 onMouseDown={onMouseDown}
 style={{'--ai-1-H9QDq': alignItems,'--bblr-4-H9QDq': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-5-H9QDq': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-6-H9QDq': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-7-H9QDq': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-8-H9QDq': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-9-H9QDq': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-10-H9QDq': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-11-H9QDq': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mt-12-H9QDq': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--w-13-H9QDq': typeof width === 'number' ? `${width}px` : width,'--bc-3-H9QDq': isHovered ? dtColorsNeutral200 : selected ? dtColorsNeutral200 : dtColorsWhite,'--c-2-H9QDq': disabled ? "default" : "pointer"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TysiaSelectOneOptionSingle.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size={size}
 text={text}
 textOverflow="none"
 overflowX="visible"
 color={disabled ? dtColorsNeutral500 : dtColorsNeutral900}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size={size}
 text="&nbsp;"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size={size}
 text={subtext}
 textOverflow="none"
 overflowX="visible"
 color={disabled ? dtColorsNeutral500 : dtColorsNeutral500}
/>
</div>
</button>
{children}
</React.Fragment>)
}